<template>
  <div id="review-order-details-loading" class="vs-con-loading__container">
    <vs-row>
      <vs-col vs-w="12">
        <vs-card v-if="detail.status_id==11">
          <vs-row vs-justify="center">
            <vs-col vs-w="3" type="flex" vs-justify="center">
              <vs-button color="success" @click="isROconfirm('yes')">
               {{$t('yes')|capitalize}}, {{$t('this_is_RO')|capitalize}}
              </vs-button>
            </vs-col>
            <vs-col vs-w="3" type="flex" vs-justify="center">
              <vs-button color="danger" @click="isROconfirm('no')">
                {{$t('no')|capitalize}}, {{$t('it_doesn_not')|capitalize}}
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>

      <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-2">
        <vs-row>
          <vs-col vs-w="12">
            <vs-card>
              <div slot="header" class="display-flex">
                <vs-col vs-w="8" vs-type="flex">
                  <feather-icon icon="PackageIcon" class="mx-1 icon-title" />
                  <h4>| {{ detail.po_number || '' }}</h4>
                </vs-col>
                <vs-col
                  vs-w="4"
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                >
                <vx-tooltip delay="0.5s" tooltipPosition="top"
                  :text="$t('show_pdf')"
                  v-if="detail.pdf_file != null">
                    <!-- <feather-icon
                      icon="FileIcon"
                      svgClasses="h-5 w-5 mr-4 cursor-pointer"
                      @click="showPDF(detail.pdf_file)"
                    /> -->
                    <action-show-pdf
                      class="icon-action"
                      :src="detail.pdf_file"
                      title="Archivo"
                      :tooltipText="$t('show_pdf')"
                      :width="1000"
                      :height="800"
                    />
                  </vx-tooltip>
                  <vx-tooltip delay="0.5s" tooltipPosition="top"
                  :text="$t('change_status')"
                  v-if="detail.status_id == 6 && hasPermission(['IU REVIEW ORDER EDIT'])">
                    <feather-icon
                      icon="SettingsIcon"

                      svgClasses="h-5 w-5 mr-4 cursor-pointer"
                      @click="confirmActive = true"
                    />
                  </vx-tooltip>
                </vs-col>
              </div>
              <review-order-detail :data="detail" :seriesSpeedMeter="total_progress" :totalDiscrepancies="total_discrepancies"/>
              <review-order-entries-table
                :totals="totals"
                :entries="entries"
                :reviewOrderId="reviewOrderId"
                @itemRemoved="itemRemoved"
                @loadingSubmit="loadingDeleteItem"
                class="mt-5"
              />
            </vs-card>
          </vs-col>
          <vs-col vs-w="12">
            <vs-card v-if="detail.status_id != 8">
              <vs-row vs-justify="flex-end">
                <vs-col vs-w="3" type="flex" vs-justify="flex-end">
                  <vs-button color="success" @click="$router.push('/update_txt/ro/'+reviewOrderId)">
                    Update Invoice File
                  </vs-button>
                </vs-col>
              </vs-row>
            </vs-card>
          </vs-col>
          <vs-col vs-w="12">
            <vs-card>
              <vs-tabs>
                <vs-tab
                  :label="$t('invoice') | capitalize"
                  icon-pack="feather"
                  icon="icon-box"
                  :disabled="invoices.length === 0"
                >
                  <div class="tab-text">
                    <review-order-invoices
                    :data="invoices"
                    :reviewOrderId="reviewOrderId"
                    :reviewOrderStatusId="reviewOrderStatusId"
                    @itemRemoved="itemRemoved"
                    @loadingSubmit="loadingDeleteItem"/> <!-- :aditionalData="tmp_invoices" -->
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('files') | capitalize"
                  icon-pack="feather"
                  icon="icon-image"
                  :disabled="files.length === 0"
                >
                  <div class="tab-text">
                    <review-order-files :data="files" />
                  </div>
                </vs-tab>
                <vs-tab
                  :label="$t('load_order') | capitalize"
                  icon-pack="feather"
                  icon="icon-truck"
                  :disabled="loadOrders.length === 0"
                >
                  <div class="tab-text">
                    <review-order-load-order :data="loadOrders" />
                  </div>
                </vs-tab>
              </vs-tabs>
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-2">
        <vs-card>
          <div slot="header" class="display-flex">
             <vs-row>
              <vs-col vs-w="12" vs-type="flex">
                <feather-icon icon="ClockIcon" class="mx-1 icon-title" />
                <h4 class="mt-1">{{ $t('timeline') | capitalize }}</h4>
              </vs-col>
            </vs-row>
          </div>
          <timeline :data="timeline" />
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-popup :title="$t('confirm')" :active.sync="confirmActive">
      <p>{{ $t('are_you_sure') }} {{$t('this_review_order_status_will_change_to_ready_for_review')}}</p>
      <vs-row vs-align="center" vs-type="flex" vs-justify="center" class="mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            ref="loadableButton"
            id="link-button-loading"
            class="w-full vs-con-loading__container"
            color="primary"
            type="filled"
            :disabled="submitButtonText != $i18n.messages[$i18n.locale].save"
            @click="changeRoStatus"
            >{{ submitButtonText }}</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            color="primary"
            type="border"
            class="w-full"
            :disabled="submitButtonText != $i18n.messages[$i18n.locale].save"
            @click="confirmActive = false"
            >{{ $t('cancel') }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

<vs-popup :title="$t('confirm')" :active.sync="modal_confirm">
      <p>{{$t('are_you_sure')}} {{message_confirm}}</p>
      <vs-row vs-align="center" vs-type="flex" vs-justify="center" class="mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            ref="loadableButton"
            id="link-button-loading"
            class="w-full vs-con-loading__container"
            color="primary"
            type="filled"
            :disabled="isLoading"
            @click="submitAnswerRO(answerRO)"
            >{{$t('i_am_sure')}}</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="mt-2 px-2"
        >
          <vs-button
            color="primary"
            type="border"
            class="w-full"
            :disabled="isLoading"
            @click="modal_confirm = false"
            >{{ $t('cancel') }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>


  </div>
</template>

<script>
import ReviewOrderInvoices from './components/ReviewOrderInvoices'
import ReviewOrderFiles from './components/ReviewOrderFiles'
import ReviewOrderLoadOrder from './components/ReviewOrderLoadOrder'
import ReviewOrderEntriesTable from './components/ReviewOrderEntriesTable'
import ReviewOrderDetail from './components/ReviewOrderDetail'
import Timeline from '@/views/components/Timeline'
import reviewOrder from '@/http/requests/reviewOrder'
import ReviewOrderImport from '@/views/modules/import_export/review_order/components/ReviewOrderImport'
import loading from '@/mixins/Loading'
import ActionShowPdf from '@/views/components/actions/ActionShowPdf.vue'

export default {
  components: {
    ActionShowPdf,
    ReviewOrderInvoices,
    ReviewOrderLoadOrder,
    ReviewOrderFiles,
    ReviewOrderDetail,
    Timeline,
    ReviewOrderEntriesTable,
    ReviewOrderImport
  },
  computed: {
    reviewOrderId () {
      return this.$route.params.id
    },
    isLoading () {
      return (
        this.loading.details ||
        this.loading.invoices ||
        this.loading.timeline ||
        this.loading.files ||
        this.loading.entries ||
        this.loading.answer_ro
      )
    }
  },
  data () {
    return {
      loading: {
        details: false,
        invoices:false,
        timeline:false,
        files:false,
        entries:false,
        load_orders:false,
        answer_ro:false
      },
      TxtErrors:true,
      validationErrors:[],
      errorsSameInfo:[],
      timeline: [],
      loadOrders: [],
      invoices: [],
      tmp_invoices: [],
      invoicesFile: {
        tables: []
      },
      entries: [],
      files: [],
      detail: {},
      totals:{
        weight:'0 lb',
        packs:'0'
      },
      confirmActive:false,
      activeUpdateFile:false,
      activeValidationFile:false,
      submitButtonText:this.$i18n.messages[this.$i18n.locale].save,
      message_confirm:'Empty Message',
      modal_confirm:false,
      answerRO:'',
      total_progress:[],
      total_discrepancies:'0',
      reviewOrderStatusId:'0'
    }
  },
  mounted () {
    this.getTimeline()
    this.getLoadOrders()
    this.getInvoices()
    this.getFiles()
    this.getDetails()
    this.getEntries()
    this.loadSpeedMeter()
  },
  methods: {
    getDetails () {
      this.loading.details=true
      reviewOrder
        .reviewDetails(this.reviewOrderId)
        .then(res => {
          this.detail = Object.assign({}, res.data.item)
          //console.log(res.data.item)
          this.reviewOrderStatusId=res.data.item.status_id
          this.loading.details=false
        })
        .catch(err => {
          this.loading.details=false
        })
    },
    showPDF(file){
      console.log('show',file);
    },
    getInvoices () {
      this.loading.invoices=true
      reviewOrder
        .reviewGetInvoices(this.reviewOrderId)
        .then(res => {
          this.loading.invoices=false
          this.invoices = [...res.data.items]
          this.tmp_invoices = [...res.data.tmps]
          let tmps=[]
          this.invoices.forEach(el => {
            tmps=this.filterTmps(this.tmp_invoices,el.id)
            if(tmps.length>0){
              el.tmps_fields=tmps[0].fields
            }else{
              el.tmps_fields={}
            }
          })
        })
        .catch(err => {
          this.loading.invoices=false
        })
    },
    filterTmps(data,invoice_id){
        return data.filter((item) => {
          return (parseInt(item.invoice_id)==parseInt(invoice_id))
        });
    },
    getLoadOrders () {
      this.loading.load_orders=true
      reviewOrder
        .reviewGetLoadOrders(this.reviewOrderId)
        .then(res => {
          this.loading.load_orders=false
          this.loadOrders = [...res.data.item]
        })
        .catch(err => {
          this.loading.load_orders=false
        })
    },
    getTimeline () {
      this.loading.timeline=true
      reviewOrder
        .getReviewTimeline(this.reviewOrderId)
        .then(res => {
          this.loading.timeline=false
          this.timeline = [...res.data.data]
        })
        .catch(err => {
          this.loading.timeline=false
        })
    },
    getFiles () {
      this.loading.files=true
      reviewOrder
        .reviewGetFiles(this.reviewOrderId)
        .then(res => {
          this.loading.files=false
          this.files = [...res.data.items]
        })
        .catch(err => {
          this.loading.files=false
        })
    },
    getEntries () {
      this.loading.entries=true
      reviewOrder
        .reviewGetEntries(this.reviewOrderId)
        .then(res => {
          this.loading.entries=false
          this.entries = res.data.items
          this.totals = res.data.totals
        })
        .catch(err => {
        this.loading.entries=false
        })
    },
    itemRemoved () {
      this.getEntries()
      this.getTimeline()
      this.getInvoices()
      this.loadSpeedMeter()
    },
    loadingDeleteItem(boolean){
      this.loading.invoices=boolean
    },
    changeRoStatus(){
      this.submitButtonText = `${this.$i18n.messages[this.$i18n.locale].loading  }...`
      let params={
        ro_id:this.reviewOrderId,
        status:4
      }
      reviewOrder.updateStatus(params).then(res => {
        this.submitButtonText = this.$i18n.messages[this.$i18n.locale].save
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: this.$i18n.messages[this.$i18n.locale].saved
        })
        this.getTimeline()
        this.getDetails()
        this.confirmActive=false
      }).catch( err => {
        this.submitButtonText = this.$i18n.messages[this.$i18n.locale].save
        this.confirmActive=false
        console.log(err)
      })
    },
    isROconfirm(answer){
      this.answerRO=answer
      if(answer=='yes'){
        this.message_confirm='SÍ es RO.'
        this.modal_confirm=true
      }
      if(answer=='no'){
        this.message_confirm='NO es RO.'
        this.modal_confirm=true
      }
    },
    submitAnswerRO(){
      this.loading.answer_ro=true
      let params={
          review_order_id:this.reviewOrderId,
          status_id:2
        }
      if(this.answerRO=='yes'){
          params.status_id=8
      }

      reviewOrder.isROanswer(params).then(res => {
        console.log(res.data.data)
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'Guardado'
        })
        this.modal_confirm=false
        this.loading.answer_ro=false
        this.getTimeline()
        this.getDetails()
      }).catch(err => {
        this.modal_confirm=false
        this.loading.answer_ro=false
        if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach((element) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0],
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
      })
    },
    loadSpeedMeter(){
      reviewOrder.speedMeter(this.reviewOrderId).then(res => {
        let progress=0
          if(res.data.data.total!='0'){
            progress = Number(res.data.data.progress/res.data.data.total*100).toFixed(2)
          }
          this.total_progress=[progress]
          this.total_discrepancies=res.data.data.discrepancies
        }).catch(err => {
          console.log(err)
        })
    }
  },
  mixins: [loading],
  watch: {
    isLoading (val) {
      if (val) {
        this.openLoading('review-order-details-loading')
      } else {
        this.closeLoading('review-order-details-loading')
      }
    }
  }
}
</script>

<style  lang="scss">
.icon-title {
  font-size: 14px;
  color: #2c2c2c;
}
.display-flex {
  display: flex;
}

.f-12 {
  font-size: 12px;
}

.custom-icon {
  width: 16px;
  height: 16px;
  top: 20%;
  .material-icons{
    font-size: 14px;
  }
}

</style>
